<div class="reset_password">
    <div class="middle-box text-center loginscreen  animated fadeInDown">
        <div>
            <img src="../../../assets/imgs/logo.png" alt="logo"/>
            <div class="login_box">
                <h3>Reset your Password</h3>
                <form class="m-t" role="form" (submit)="submit()">
                    <div class="row">
                        <div class="col-xs-12 mh-64">
                            <app-epa-input label="Email *" [control]="resetPasswordForm.get('email')">
                            </app-epa-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <app-password-verification [password]="resetPasswordForm.get('password')" 
                                                        [confirmPassword]="resetPasswordForm.get('confirmPassword')"
                                                        [required]="true">
                            </app-password-verification>
                        </div>
                    </div>                    
                    <button type="submit" class="btn btn-primary block full-width m-b m-t-sm">Submit</button>
                </form>
            </div>
        </div>
    </div>
</div>
